import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { AdminChatUser, ChatsList } from "@/features/chats";
import { useTrainerChats } from "../model/TrainerChatsContext";

import styles from "./TrainerChatsListPage.module.scss";

export const TrainerChatsListPage = () => {
  const navigate = useNavigate();
  const { chats, chatsLoading } = useTrainerChats();

  const description = useMemo(() => {
    if (!chats.length) {
      return "Список клиентов пуст. Как только клиенты начнут писать, они появятся здесь.";
    }

    return "Выберите клиента, чтобы открыть его профиль, анкету и переписку.";
  }, [chats.length]);

  return (
    <section className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerTop}>
          <div>
            <h3 className={styles.title}>Мои клиенты</h3>
            <p className={styles.description}>{description}</p>
          </div>
        </div>
      </header>

      <ChatsList
        chats={chats}
        onSelect={(userId) => navigate(`/trainer/clients/${userId}`)}
        isLoading={chatsLoading}
        className={styles.list}
        showTitle={false}
      />
    </section>
  );
};

